import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input': {
    color: theme.palette.text.primary,
    WebkitTextFillColor: theme.palette.text.primary,
    '&::placeholder': {
      fontStyle: 'italic',
      opacity: 1,
    },
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: theme.palette.text.disabled,
    WebkitTextFillColor: theme.palette.text.disabled,
  },
}));
